import { useQuery } from '@apollo/client';

import { queryParams } from 'app/shared/utils/queries';
import { SharedGetDataParameters } from 'app/shared/typings/generics';
import { PrismicDocument } from 'app/shared/typings/prismic';
import {
  GET_COMPETITION_PAGE,
  GET_DYNAMIC_PAGE,
  GET_DYNAMIC_PAGE_URL,
  GET_PAGE,
} from 'app/shared/graphql/prismic/queries';

export interface GetCompetitionPageVariables extends SharedGetDataParameters {
  cachedSlug?: string;
  locale?: string;
}

export interface GetDynamicPageUrlVariables extends SharedGetDataParameters {
  url?: string;
  locale?: string;
}

export interface GetPageVariables extends SharedGetDataParameters {
  slug?: string;
  locale?: string;
}

export interface GetPageData {
  page: PrismicDocument;
  competitionPage?: PrismicDocument;
}

export const GetCompetitionPage = (params: GetCompetitionPageVariables) => {
  return useQuery<GetPageData>(GET_COMPETITION_PAGE, queryParams(params));
};

export const GetDynamicPage = (params: GetPageVariables = {}) => {
  return useQuery<GetPageData>(GET_DYNAMIC_PAGE, queryParams(params));
};

export const GetDynamicPageUrl = (params: GetDynamicPageUrlVariables = {}) => {
  return useQuery<GetPageData>(GET_DYNAMIC_PAGE_URL, queryParams(params));
};

export const GetPage = (params: GetPageVariables = {}) => {
  return useQuery<GetPageData>(GET_PAGE, queryParams(params));
};
